import React, { useEffect, useState } from "react";
import Container from "../../Container";
import Heading from "../../../Components/Heading/Heading";
import { Link } from "react-router-dom";

const CategoryFooter = ({ Category }) => {
  // const [Category, setCategory] = useState([]);

  // const getOurProducts = async () => {
  //   var requestOptions = {
  //     method: "GET",
  //     redirect: "follow",
  //   };

  //   await fetch(
  //     "https://main-backend.hapspro.com/admin/getHomeZoneAppliances",
  //     requestOptions
  //   )
  //     .then((response) => response.json())
  //     .then((result) => {
  //       console.log(result);
  //       setCategory(result.data);
  //     })
  //     .catch((error) => console.log("error", error));
  // };

  // useEffect(() => {
  //   getOurProducts();
  // }, []);

  return (
    <div className="my-10">
      <h1 className="text-4xl font-bold text-center">Our Products</h1>
      <div className="grid grid-cols-3 md:grid-cols-5 xl:grid-cols-8 gap-x-4 md:gap-x-6 gap-y-4 my-4">
        {Category &&
          Category.map((el) => el.category) // Extract all subcategories
            .flat() // Flatten them into a single array
            .map((subCat) => {
              return (
                <Link
                  to={`/category/${subCat.slug}`}
                  key={subCat.id}
                  className="flex flex-col items-center justify-center"
                >
                  <img
                    src={
                      process.env.REACT_APP_HAPS_MEDIA_BASE_URL + subCat.image
                    }
                    alt={subCat.title || 'Not Available'}
                    className="rounded-xl transition-transform duration-700 hover:scale-105 w-[110px] h-[110px] md:w-[140px] md:h-[140px] object-contain"
                  />
                  <p className="font-bold text-center pt-2 text-xs md:text-md lg:text-md xl:text-md">
                    {subCat.title || "No Title"}
                  </p>
                </Link>
              );
            })
        }
      </div>


    </div>
  );
};

export default CategoryFooter;
